// Maps the raw `charger` blob onto CarCard's flat props.
// CarCard does NOT accept a `charger` object — every page renderer must go
// through this, otherwise the card silently falls back to its defaults
// (isCharging=false, no power, no profile) and shows stale/idle state.
// Dependency-free on purpose: pages import it eagerly while CarCard stays lazy.
export function carCardProps(charger = {}) {
  return {
    isCharging:                charger?.isCharging                ?? false,
    chargingPowerKw:           charger?.power                     ?? null,
    chargingAmpMqtt:           charger?.ampMqtt                   ?? null,
    balancingProfile:          charger?.balancingProfile          ?? null,
    useHouseBattery:           charger?.useHouseBattery           ?? true,
    minSoCThreshold:           charger?.minSoCThreshold           ?? 20,
    useHouseBatteryBonus:      charger?.useHouseBatteryBonus      ?? 0,
    startPeakShavingThreshold: charger?.startPeakShavingThreshold ?? 30,
    carForceAmpere:            charger?.carForceAmpere            ?? 0,
  }
}
